import { Empty as AntEmpty } from 'antd'
import React from 'react'

import emptySvg from './noData.svg'

/**
 * 自定义空状态组件
 *
 * @param param - 参数
 * @param param.imageSrc - 图片 src 地址
 * @returns React.ReactNode
 */
export const Empty: React.FC = () => {
  return (
    <AntEmpty
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
      imageStyle={{
        width: 200,
        height: 150,
      }}
      image={emptySvg}
      description={''}
    />
  )
}
